export default __webpack_public_path__ + "static/media/43.1076261d.png";